/**
 * Utility functions for Patchwerk
 */

// Re-export binary utilities
export * from './binary.js';

/**
 * Generate a unique ID string
 */
export function generateId() {
    return 'id-' + Math.random().toString(36).substr(2, 9);
}

/**
 * Escape HTML special characters to prevent XSS
 */
export function escapeHtml(str) {
    const div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
}

/**
 * Format a timestamp into a human-readable relative time
 */
export function formatTimestamp(ts) {
    const date = new Date(ts);
    const now = new Date();
    const diff = now - date;
    
    if (diff < 60000) return 'just now';
    if (diff < 3600000) return Math.floor(diff / 60000) + 'm ago';
    if (diff < 86400000) return Math.floor(diff / 3600000) + 'h ago';
    if (diff < 604800000) return Math.floor(diff / 86400000) + 'd ago';
    
    return date.toLocaleDateString();
}
